export function filterNulls<T>(a: T[]) {
  return a.filter((i) => i !== null);
}
